import React from 'react';
import "../../../assets/css/Footer.css";
import { Link } from "react-router-dom"; 
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-footer">
        <div className="row">
          <div className="col-md-12 text-center">
            <p style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: '5px', margin:'0px' }}>
              <a href="mailto:u@utharamenon.com">u@utharamenon.com</a> | 
              <a href="tel:+916367563765">+91 6367563765</a> | 
              <Link to="/privacy-policy">Privacy Policy</Link> | 
              
              <a 
                href="https://www.instagram.com/utharamenon_u/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '5px', textDecoration: 'none', color: 'inherit' }}
              >
                <FaInstagram size={16} /> utharamenon_u
              </a> | 

              <a 
                href="https://www.instagram.com/sewrighttailors/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '5px', textDecoration: 'none', color: 'inherit' }}
              >
                <FaInstagram size={16} /> sewrighttailors
              </a>
            </p>

            {/* <p>
              3A, 1st Floor, Mathura Apartments, No.1, Masilamani Street, T.Nagar, Chennai, Tamil Nadu - 600017
            </p> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
